import { TheaterStatus } from '@/enums/theater-status';

export const isTheaterTemporarilyClosed = (status: string | null | undefined): boolean =>
  status === TheaterStatus.ClosedTemporarily || status === 'Temporarily Closed';
